import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { RefereeViewDetailComponent } from '../referee-view-detail/referee-view-detail.component';
import { EditRefereeComponent } from '../edit-referee/edit-referee.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatPaginator } from '@angular/material/paginator';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  serialNumber?: number;
  agentName?: string;
  email?: string;
  phoneNumber?: string;
  agentType?: string;
  assignedLeads?: string;
  status?: string;
  action?: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'active' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'inactive' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];

@Component({
  selector: 'app-refree-list',
  imports: [MaterialModule, CommonModule],
  templateUrl: './refree-list.component.html',
  styleUrl: './refree-list.component.scss'
})
export class RefreeListComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ['serialNumber', 'agentName', 'email', 'phoneNumber', 'assignedLeads', 'action'];
  dataSource = ELEMENT_DATA;
  temporaryList: any[];
  pageSize: number = 5;
  pageIndex: any;
  totalCount: any;




  constructor(
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.getRefereeList();
  }

  // ngAfterViewInit(){
  //   this.updatePagedData();
  // }

  getRefereeList() {
    console.log(this.dataSource)
    this.temporaryList = ELEMENT_DATA;
    this.totalCount = 10;
    // this.updatePagedData();
  }

  viewDetail(element: any) {
    const dialogRef = this.dialog.open(RefereeViewDetailComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  edit(element: any) {
    const dialogRef = this.dialog.open(EditRefereeComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  deleteItem(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      panelClass: 'confirm-dialog',
      position: {
        top: '10px', // Align to the top
        // left: '40%', // Center horizontally
      },
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          yes: 'yes',
          no: 'no'
        }
      },
    }).afterClosed().subscribe((result: any) => {
      console.log('Dialog closed with result:', result);
      if (result === true) {
        // Perform delete operation or further logic
      }
    });
  }

  // Handle page change event from paginator
  onPageChange(event: any) {
    console.log('page', event)
    this.pageSize = event.pageSize; // Update page size
    // this.paginator.pageIndex = 0;
    this.updatePagedData(); // Update the paged data
  }

  /**
   * Update the paged data based on the paginator's current page.
   */
  updatePagedData() {
    const startIndex = this.paginator.pageIndex * this.pageSize;
    this.pageIndex = this.paginator.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource = this.temporaryList.slice(startIndex, endIndex);
  }

  approve(element: any) { }
  reject(element: any) {

  }
}
